var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"corner-module"},[_vm._v(" Copright @ ramnil.com. All right resiverd. ")])])
}]

export { render, staticRenderFns }